import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  formLoading: false,
  formError: null,
  loadedEntity: null,
  parentEntities: [],
  formSubmitSuccess: false,
  entitySummary: {},
  entityActivities: [],
  reporters: {
    entityId: 0,
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
    formLoading: false,
    formError: null,
    formSubmitSuccess: false,
  },
};

export const entitySlice = createSlice({
  name: 'entity',
  initialState,
  reducers: {
    createEntityRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    createEntitySuccess: (state, {payload}) => {
      state.formLoading = false;
      state.loadedEntity = payload;
      state.formSubmitSuccess = true;
    },
    createEntityError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    fetchParentEntitiesRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchParentEntitiesSuccess: (state, {payload}) => {
      state.formLoading = false;
      state.parentEntities = payload;
    },
    fetchParentEntitiesError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.parentEntities = [];
    },
    resetFormSubmitSuccess: (state, {payload}) => {
      const {formName, flagValue} = payload;
      if (formName === 'entity') {
        state.formSubmitSuccess = flagValue;
      } else if (formName === 'reporter') {
        state.reporters.formSubmitSuccess = flagValue;
      }
    },
    fetchEntityRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchEntitySuccess: (state, {payload}) => {
      state.formLoading = false;
      state.loadedEntity = payload;
    },
    fetchEntityError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.loadedEntity = null;
    },

    updateEntityRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    updateEntitySuccess: (state, {payload}) => {
      state.formLoading = false;
      state.loadedEntity = payload;
      state.formSubmitSuccess = true;
    },
    updateEntityError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
    },
    fetchEntitySummaryRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchEntitySummarySuccess: (state, {payload}) => {
      state.formLoading = false;
      state.entitySummary = payload;
    },
    fetchEntitySummaryError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.entitySummary = {};
    },

    fetchEntityActivitiesRequest: (state) => {
      state.formLoading = true;
      state.formError = null;
    },
    fetchEntityActivitiesSuccess: (state, {payload}) => {
      state.formLoading = false;
      state.entityActivities = payload;
    },
    fetchEntityActivitiesError: (state, {payload}) => {
      state.formLoading = false;
      state.formError = payload;
      state.entityActivities = [];
    },
    fetchEntityReportersRequest: (state) => {
      state.reporters.loading = true;
      state.reporters.error = null;
    },
    fetchEntityReportersSuccess: (state, {payload}) => {
      const {
        data,
        page,
        pageSize,
        totalPages,
        totalRecords,
        sortOn,
        sortDir,
        entityId,
      } = payload;
      state.reporters.entityId = entityId;
      state.reporters.loading = false;
      state.reporters.data = data;
      state.reporters.page = page;
      state.reporters.pageSize = pageSize;
      state.reporters.totalPages = totalPages;
      state.reporters.totalCount = totalRecords;
      state.reporters.sortOn = sortOn;
      state.reporters.sortDir = sortDir;
    },
    fetchEntityReportersError: (state, {payload}) => {
      state.reporters.loading = false;
      state.reporters.error = payload;
    },
    sendReporterInviteRequest: (state) => {
      state.reporters.formLoading = true;
      state.reporters.formError = null;
    },
    sendReporterInviteSuccess: (state) => {
      state.reporters.formLoading = false;
      state.reporters.formSubmitSuccess = true;
    },
    sendReporterInviteError: (state, {payload}) => {
      state.reporters.formLoading = false;
      state.reporters.formError = payload;
    },
  },
});

export const {
  createEntityRequest,
  createEntitySuccess,
  createEntityError,
  fetchParentEntitiesRequest,
  fetchParentEntitiesSuccess,
  fetchParentEntitiesError,
  resetFormSubmitSuccess,
  fetchEntityRequest,
  fetchEntitySuccess,
  fetchEntityError,
  updateEntityRequest,
  updateEntitySuccess,
  updateEntityError,
  fetchEntitySummaryRequest,
  fetchEntitySummarySuccess,
  fetchEntitySummaryError,
  fetchEntityActivitiesRequest,
  fetchEntityActivitiesSuccess,
  fetchEntityActivitiesError,
  fetchEntityReportersRequest,
  fetchEntityReportersSuccess,
  fetchEntityReportersError,
  sendReporterInviteRequest,
  sendReporterInviteSuccess,
  sendReporterInviteError,
} = entitySlice.actions;

export default entitySlice.reducer;
